module.exports = __webpack_public_path__ + "static/img/vr7.a798f196.png";